module.exports = __webpack_public_path__ + "static/media/plate2Img1.ae270263.png";